<template>
  <v-content>
    <v-container>
      <list
        ref="list"
        :title="title"
        :headers="headers"
        :data="data"
        :response="response"
        :loading="loading"
        @edit="editFn"
        @delete="deleteFn"
        @details="previewFn"
        @new="newFn"
        @reload="loadDocuments()"
        @sort="loadDocuments()"
        @hook:mounted="handleMount('list')"
      />
      <delete-dialog
        :dialog="deleteDialog"
        :item="documentName"
        @agree="remove"
        v-show="false"
      />
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import List from "@/components/lists/BuilderList.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import snackbar from "@/utils/snackbar.js";
import categories from "@/utils/categories.js";
export default {
  components: {
    List,
    DeleteDialog,
  },
  data: () => ({
    mounted: {
      list: { mounted: false, refs: "list" },
      root: { mounted: false, refs: null },
    },
    headers: [],
    data: [],
    sort: "name",
    title: "Documents",
    deleteDialog: false,
    documentName: null,
    document: null,
    loading: true,
    response: null,
    categoryOptions: [],
  }),
  created() {
    this.setInitialData();
    this.categoryOptions = categories.categoryOptions();
  },

  mounted() {
    //NOTE: this is here to prevent multiple API calls to the same function. To gether all the parameters from the different components.
    this.handleMount("root");
  },

  methods: {
    handleMount(componentName) {
      if (!this.mounted.hasOwnProperty(componentName)) {
        console.error(
          "DOCUMENTS:component name does not exists",
          componentName
        );
        return;
      }

      this.mounted[componentName] = {
        ...this.mounted[componentName],
        mounted: true,
      };

      if (Object.values(this.mounted).every((item) => item.mounted)) {
        this.loadDocuments();
      }
    },
    setInitialData() {
      this.headers = [
        {
          text: this.$t("builder.documents.list.documentTitle"),
          align: "left",
          sortable: true,
          orderingName: "document_name",
          value: "title",
        },
        {
          text: this.$t("builder.documents.list.visibility"),
          align: "left",
          sortable: true,
          orderingName: "document_visibility",
          value: "crm_group.name",
        },
        {
          text: this.$t("builder.documents.list.category"),
          align: "left",
          sortable: true,
          orderingName: "document_category",
          value: "categories",
        },
        { text: "", align: "right", value: "action", sortable: false },
      ];

      this.title = this.$t("builder.documents.list.documents");
    },
    loadDocuments() {
      let params = {};

      for (const key in this.mounted) {
        const refs = this.mounted[key].refs;
        if (refs == null) continue;
        params = {
          ...params,
          ...this.$refs[refs].query,
        };
      }

      this.$router.replace({
        name: this.$route.name,
        query: params,
      });
      this.loading = true;
      this.data = [];
      api.getDocumentList(params).then((resp) => {
        this.loading = false;
        this.response = resp.data;
        this.data = resp.data.results;
      });
    },
    editFn(item) {
      this.$router.push({
        name: "documentsEdit",
        params: { id: item.uuid, action: "edit" },
      });
    },
    deleteFn(item) {
      this.deleteDialog = true;
      this.document = item;
      this.documentName = item.title;
    },

    remove(agreed) {
      if (agreed) {
        api.deleteDocument(this.document.uuid).then((resp) => {
          snackbar.success(
            this.$t("utils.snackbar.success.successfullyDeleted")
          );
          this.loadDocuments();
          // api.getDocumentList().then((resp) => {
          //   snackbar.success("Successfully deleted");
          //   this.data = resp.data.results;
          // });
        });
      }
      this.deleteDialog = false;
    },
    previewFn(item) {
      this.$router.push({
        name: "documentsDetails",
        params: { id: item.uuid, action: "preview" },
      });
    },
    newFn(item) {
      this.$router.push({
        name: "documentsAdd",
        params: { id: "-", action: "new" },
      });
    },
  },
};
</script>
